import React, { Component } from 'react';

import { FilePond, registerPlugin } from 'react-filepond';
import '!style-loader!css-loader!filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import '!style-loader!css-loader!filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileRename,
  FilePondPluginFileMetadata,
  FilePondPluginImageValidateSize
);

class Fileuploader extends Component {
  manualBrowse() {
    this.filepond._pond.browse();
  }

  getPond() {
    return this.filepond._pond;
  }

  render() {
    let pondProps = {
      allowImagePreview: true,
      allowFileTypeValidation: true,
      allowFileRename: true,
      allowFileMetadata: true,
      allowImageValidateSize: false,
      labelFileTypeNotAllowed: 'Please upload a file of the correct type',
      labelIdle: 'Drag & Drop your file or <span class="filepond--label-action">Browse</span>',
      ...this.props,
    };

    return <FilePond {...pondProps} ref={ref => (this.filepond = ref)}></FilePond>;
  }
}

export default Fileuploader;
